import Navbar from "../components/navbar"
import { useState } from "react"
import { FaBars } from "react-icons/fa"
import ProgressBar from "../components/progress-bar"
import { Button, Steps, theme, Select, Space, DatePicker } from "antd"
import { Link } from "react-router-dom"
import FloatingInput from "../components/floatingInput"
import { BsPlus } from "react-icons/bs"

const ProfessionalInfoPage = () => {
    const [navShown, setNavShown] = useState("hidden")
    const [showBar, setShowBar] = useState(true)
    const [showXmark, setShowXmark] = useState("hidden")
    const [current, setCurrent] = useState(0);
    const [licensureStateOptions, setLicensureStateOptions] = useState(["Accute Care Float", "Trauma ICU", "Urgent Care", "Utilization Review", "Vaccination Review", "Wound Care", "Transplant"])
    const [licensureStateSearch, setLicensureStateSearch] = useState()
    const [certificateOptions, setCertificateOptions] = useState(["Accute Care Float", "Trauma ICU", "Urgent Care", "Utilization Review", "Vaccination Review", "Wound Care", "Transplant"])
    const [certificateSearch, setCertificateSearch] = useState()
    const [additionalInfo, setAdditionalInfo] = useState()
    const { token } = theme.useToken();
    const { Option } = Select;

    const openNav = () => {
        setNavShown("block")
        setShowBar("hidden")
        setShowXmark("inline")
    }
    const closeNav = () => {
        setNavShown("hidden")
        setShowBar("inline")
        setShowXmark("hidden")
    }

    const steps = [
        {
            title: 'Licenses',
            content: <div className="w-full">
                <form className="p-4">
                    <div className="flex items-center gap-3 justify-center lg:justify-normal flex-wrap lg:flex-nowrap">
                        <div>
                            <h1 className="text-gray-500 text-xs">
                                Licensure State
                            </h1>
                            <Select
                                mode="multiple"
                                maxLength={1}
                                className="w-[180px]"
                                placeholder="select licensure state"
                                optionLabelProp="label"
                                value={licensureStateSearch}
                                onChange={(e) => {
                                    setLicensureStateSearch(e[e.length - 1])
                                }}
                            >

                                {
                                    licensureStateOptions?.map((val, i) => {
                                        return (
                                            <Option key={i} value={val} label={val}>
                                                <Space>
                                                    {val}
                                                </Space>
                                            </Option>
                                        )
                                    })
                                }
                            </Select>
                        </div>
                        <div className="relative top-2">
                            <FloatingInput id={"number"} title={"Number"} onChange={(e) => console.log(e)} />
                        </div>
                        <div className="relative top-2">
                            <DatePicker placeholder="Issuance date" className="bg-transparent py-3 w-[180px]" />
                        </div>
                        <div className="relative top-2">
                            <DatePicker placeholder="Expiration date" className="bg-transparent py-3 w-[180px]" />
                        </div>
                        <div className="lg:relative -top-1">
                            <span className="text-xs text-gray-500 block">
                                Active compact Status
                            </span>
                            <select className="w-[180px] border-gray-300 py-3 rounded-lg">
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </select>
                        </div>
                    </div>
                    <div className="mt-6">
                        <button className="bg-cyan-400 p-2 rounded-full font-semibold flex items-center gap-x-1">
                            <BsPlus className="text-xl" />
                            <span className="uppercase">
                                Add license
                            </span>
                        </button>
                    </div>
                </form>
            </div>
        },
        {
            title: 'Certifications',
            content: <div className="w-full">
                <form className="p-4">
                    <div className="flex items-center gap-3 justify-center lg:justify-normal flex-wrap lg:flex-nowrap">
                        <div>
                            <h1 className="text-gray-500 text-xs">
                                Certifiaction
                            </h1>
                            <Select
                                mode="multiple"
                                maxLength={1}
                                className="w-[180px]"
                                placeholder="Select certication"
                                optionLabelProp="label"
                                value={certificateSearch}
                                onChange={(e) => {
                                    setCertificateSearch(e[e.length - 1])
                                }}
                            >

                                {
                                    certificateOptions?.map((val, i) => {
                                        return (
                                            <Option key={i} value={val} label={val}>
                                                <Space>
                                                    {val}
                                                </Space>
                                            </Option>
                                        )
                                    })
                                }
                            </Select>
                        </div>
                        <div className="relative top-2">
                            <DatePicker placeholder="Expiration date" className="bg-transparent py-3 w-[180px]" />
                        </div>
                    </div>
                    <div className="mt-6">
                        <button className="bg-cyan-400 p-2 rounded-full font-semibold flex items-center gap-x-1">
                            <BsPlus className="text-xl" />
                            <span className="uppercase">
                                Add Certification
                            </span>
                        </button>
                    </div>
                </form>
            </div>
        },
        {
            title: 'Additional Info',
            content: <div className="w-full">
                <form className="p-4">
                    <textarea value={additionalInfo} onChange={(e) => setAdditionalInfo(e.target.value)} maxLength={500} name="" id="" className="w-full rounded placeholder:text-gray-400" placeholder="What are some details you would like us to shre with facilities that make you an extra special candidate" rows="3"></textarea>
                    <div className="flex justify-between items-center">
                        <p className="text-gray-400 text-[10px]">
                            Additional courses or certifications, professional memberships, or other qualifications
                        </p>
                        <span className="text-gray-400 text-[10px]">
                            {
                                additionalInfo?.length
                            }/500
                        </span>
                    </div>
                </form>
            </div>
        },
        {
            title: 'Charting Systems',
            content: <div className="w-full">
                <form className="p-4">
                    <div className="flex gap-x-3">
                        <div>
                            <p>Do you Have experience with any of these EMR/EHR systems?</p>
                            <span className="text-xs text-gray-500">
                                Select all that apply
                            </span>
                        </div>
                        <div className="flex flex-col">
                            <label className="flex items-center gap-x-1">
                                <input type="checkbox" name="" id="" />
                                Allscripts
                            </label>
                            <label className="flex items-center gap-x-1">
                                <input type="checkbox" name="" id="" />
                                Centricity
                            </label>
                            <label className="flex items-center gap-x-1">
                                <input type="checkbox" name="" id="" />
                                Cerner
                            </label>
                            <label className="flex items-center gap-x-1">
                                <input type="checkbox" name="" id="" />
                                Epic
                            </label>
                            <label className="flex items-center gap-x-1">
                                <input type="checkbox" name="" id="" />
                                GE Healthcare
                            </label>
                            <label className="flex items-center gap-x-1">
                                <input type="checkbox" name="" id="" />
                                Health Connect
                            </label>
                            <label className="flex items-center gap-x-1">
                                <input type="checkbox" name="" id="" />
                                Horizon
                            </label>
                        </div>
                        <div className="flex flex-col">
                            <label className="flex items-center gap-x-1">
                                <input type="checkbox" name="" id="" />
                                McKesson
                            </label>
                            <label className="flex items-center gap-x-1">
                                <input type="checkbox" name="" id="" />
                                Meditech
                            </label>
                            <label className="flex items-center gap-x-1">
                                <input type="checkbox" name="" id="" />
                                Siemens
                            </label>
                            <label className="flex items-center gap-x-1">
                                <input type="checkbox" name="" id="" />
                                Sunrise
                            </label>
                            <div class="relative top-2">
                                <textarea id="floating_outlined" class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " />
                                <label for="floating_outlined" class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Other (please list)</label>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        },
        {
            title: 'Background',
            content: <div className="w-full">
                <form className="p-4">
                    <div className="flex flex-col gap-y-2">
                        <div className="flex gap-x-4">
                            <div className="lg:w-[300px]">
                                Have you ever been named as a defendant in a professional liability action?
                            </div>
                            <div className="flex items-center gap-x-3">
                                <label className="flex gap-x-1 items-center">
                                    Yes
                                    <input type="radio" name="defendant" id="" />
                                </label>
                                <label className="flex gap-x-1 items-center">
                                    No
                                    <input type="radio" name="defendant" id="" />
                                </label>
                            </div>
                        </div>
                        <div className="flex gap-x-4">
                            <div className="lg:w-[300px]">
                                Has action ever been taken against your professional license?
                            </div>
                            <div className="flex items-center gap-x-3">
                                <label className="flex gap-x-1 items-center">
                                    Yes
                                    <input type="radio" name="defendant" id="" />
                                </label>
                                <label className="flex gap-x-1 items-center">
                                    No
                                    <input type="radio" name="defendant" id="" />
                                </label>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        },
    ];

    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));
    const contentStyle = {
        // lineHeight: '260px',
        // textAlign: 'center',
        // color: token.colorTextTertiary,
        backgroundColor: token.colorFillAlter,
        // borderRadius: token.borderRadiusLG,
        // border: `1px dashed ${token.colorBorder}`,
        // marginTop: 16,
    };

    const next = () => {
        setCurrent(current + 1)
    };
    const prev = () => {
        setCurrent(current - 1);
    };


    return (
        <Navbar active={"profile"} navShow={navShown}>
            <div className="flex w-full bg-cyan-900 items-center fixed z-20">
                <FaBars className={`text-[20px] text-white relative left-4 lg:hidden ${showBar}`} onClick={openNav} />
                <span className={`text-[25px] ${showXmark} text-white font-bold relative left-72`} onClick={closeNav}>
                    X
                </span>
                <h1 className="text-center text-white py-4 w-full font-semibold">Professional Info</h1>
            </div>
            <div className="relative top-14">
                <div className="p-3">
                    <h1 className="font-semibold">Application Progress</h1>
                    <div className="mt-3">
                        <ProgressBar active={"professional info"}/>
                    </div>
                    <div className="p-2 mt-4 rounded-lg" style={{ boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px" }}>
                        <Steps current={current} items={items} />
                        <div style={contentStyle}>{steps[current].content}</div>
                        <div
                            style={{
                                marginTop: 24,
                            }}
                        >
                            {current < steps.length - 1 && (
                                <Button onClick={() => next()}>
                                    Next
                                </Button>
                            )}
                            {current === steps.length - 1 && (
                                <Link to={"/work-history"} className="bg-blue-500 p-1 rounded text-white hover:!text-white">
                                    Done
                                </Link>
                            )}
                            {current > 0 && (
                                <Button
                                    style={{
                                        margin: '0 8px',
                                    }}
                                    onClick={() => prev()}
                                >
                                    Previous
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Navbar>
    )
}

export default ProfessionalInfoPage